import ProductDetails from "@/app/shared/ecommerce/product/product-details";
import PageHeader from "@/app/shared/page-header";
import { metaObject } from "@/config/site.config";
import routes from "@/routers/routes";
import { useParams } from "react-router-dom";

export const metadata = {
    ...metaObject("Product Details"),
};

export default function ProductDetailsPage() {
    const { id } = useParams();

    const pageHeader = {
        title: "Shop",
        breadcrumb: [
            {
                href: routes.eCommerce.dashboard,
                name: "E-Commerce",
            },
            {
                href: routes.eCommerce.shop,
                name: "Shop",
            },
            {
                name: id!,
            },
        ],
    };
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            />
            <ProductDetails />
        </>
    );
}
